"use client";

import { usePathname } from "next/navigation";
import InAppBrowserNotice from "./index";
import { showsShopInAppNotice } from "./shop-paths";

/** The banner, mounted once in the locale layout for every shop page (shop-paths.ts). */
export function ShopInAppBrowserNotice() {
  const pathname = usePathname();
  if (!showsShopInAppNotice(pathname)) return null;
  return <InAppBrowserNotice />;
}
